<template>
  <v-data-table
    v-model="vendas_selecionadas"
    :headers="headers"
    :items="items"
    :search="pesquisa"
    :fixed-header="true"
    :items-per-page="-1"
    class="ml-2 table-full-screen"
    :height="height"
    show-select
    item-key="index"
    checkbox-color="primary"
    :item-class="itemClass"
    :hide-default-footer="hideDefaultFooter"
  >
    <template #top>
      <div class="d-flex align-center py-3 px-3">
        <v-icon size="22" class="mr-1">mdi-format-list-bulleted</v-icon>
        <span class="font-19 text-gray-900 font-weight-medium">Listagem das vendas</span>

        <DesconsiderarConsumos
          v-if="vendas_selecionadas.length > 0"
          :idgrupo="produto.id_grupo"
          :idfornecedor="produto.idfornecedor"
          :pedidos="vendas_selecionadas"
          habilitar_botao_grande
          @consumos-desconsiderados="consumosDesconsiderados();"
        />

        <v-spacer />

        <div class="w-450">
          <v-text-field
            v-model="pesquisa"
            dense
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
            class="mr-2"
          />
        </div>
      </div>
    </template>

    <template #body.prepend>
      <tr class="font-weight-bold">
        <td></td>
        <td>Total Geral</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>{{ Helpers.formatarValor(converteEmbalagemValor(TOTAL_SAIDAS)) }}</td>
        <td>-</td>
        <td>{{ Helpers.formatarValorMonetario(converteEmbalagemValor(TOTAL_GERAL)) }}</td>
        <td :colspan="headers.length - 6"></td>
      </tr>
    </template>

    <template #item.qtde="{ item }">
      {{Helpers.formatarValor(converteEmbalagemValor(item.qtde))}}
    </template>

    <template #item.valor_unit="{ item }">
      {{Helpers.formatarValorMonetario(item.valor_unit)}}
    </template>

    <template #item.total="{ item }">
      {{Helpers.formatarValorMonetario(item.total)}}
    </template>

    <template #item.filial="{item}">
      Filial {{item.filial}}
      <span v-if="item.nome_fantasia"> - {{ item.nome_fantasia }}</span>
    </template>

    <template #item.acoes="{item}">
      <DesconsiderarConsumos
        :idgrupo="produto.id_grupo"
        :idfornecedor="produto.idfornecedor"
        :pedidos="[item]"
        @consumos-desconsiderados="consumosDesconsiderados()"
      />
    </template>
  </v-data-table>
</template>
<script>
import DesconsiderarConsumos from "@/components/produto/detalhes/UltimasVendas/DesconsiderarConsumos.vue";

export default {
  components: {
    DesconsiderarConsumos
  },
  props: {
    produto: Object,
    headers: Array,
    items: Array,
    height: {
      type: String,
      default: 'calc(100vh - 570px)',
    },
    hideDefaultFooter: Boolean
  },
  data: () => ({
    vendas_selecionadas: [],
    pesquisa: ''
  }),
  computed: {
    TOTAL_SAIDAS() {
      const callback = (a, b) => a + (b.pedido_desconsiderado ? 0 : Number(b.qtde));
      return this.items.reduce(callback, 0);
    },
    TOTAL_GERAL() {
      const callback = (a, b) => a + Number(b.total);
      return this.items.reduce(callback, 0);
    },
    embalagemMasterAtivada() {
      return this.$store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"];
    }
  },
  methods: {
    converteEmbalagemValor(valor) {
      const multiploCompra = this.produto.multiplo_compra || 1;

      if (this.produto.tipo_fator_conversao === 'D') {
        return this.embalagemMasterAtivada ? (valor / multiploCompra) : valor;
      }

      return this.embalagemMasterAtivada ? (valor * multiploCompra) : valor;
    },
    consumosDesconsiderados() {
      this.vendas_selecionadas = [];
      this.$emit('consumos-desconsiderados', {});
    },
    itemClass(item) {
      return {
        'text-gray-100': item.pedido_desconsiderado,
      };
    }
  }
}
</script>
<style>

</style>
